import { connect } from "react-redux";
import { createSelector } from "reselect";
import { Maybe } from "true-myth";

import DayView from "components/schedule/day_view";
import { selectStoreLocation, selectDayParts } from "store/select/account";
import { ILocation, IDayPart } from "types/account";

interface IMapStateToProps {
  dayParts: IDayPart[];
  storeLocation: Maybe<ILocation>;
}

const mapStateToPropsSelector = createSelector(
  selectDayParts,
  selectStoreLocation,
  (dayParts, storeLocation): IMapStateToProps => ({ dayParts, storeLocation })
);

export default connect(mapStateToPropsSelector)(DayView);
